import { render, staticRenderFns } from "./FeatureCardZdmButtons.vue?vue&type=template&id=a5240cd4&scoped=true&"
import script from "./FeatureCardZdmButtons.vue?vue&type=script&lang=js&"
export * from "./FeatureCardZdmButtons.vue?vue&type=script&lang=js&"
import style0 from "./FeatureCardZdmButtons.vue?vue&type=style&index=0&id=a5240cd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5240cd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBadge,VCol,VRow})
